export const HOME = '/'
export const CATALOG = '/catalog'
export const PRODUCT = '/product/:id'
export const PROFILE = '/profile'
export const CART = '/cart'
// export const PAYMENT = '/payment'
export const ADMIN_CATALOG = '/admin-catalog'